// Hilvana — JS propio, vanilla, sin librerías. Un init por componente,
// todos llamados desde un único DOMContentLoaded (ver fase 4, punto 9).

(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;

    function revelarTodo() {
      els.forEach(function (el) {
        el.classList.add('mt-visible');
      });
    }

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      typeof IntersectionObserver === 'undefined'
    ) {
      revelarTodo();
      return;
    }

    els.forEach(function (el, i) {
      if (!el.style.getPropertyValue('--mt-delay')) {
        el.style.setProperty('--mt-delay', el.dataset.mtDelay || (i % 6));
      }
    });

    // Red de seguridad: si por lo que sea el observer no dispara (vistas
    // previas embebidas en iframe, extensiones, pestañas en segundo plano...)
    // el contenido no debe quedarse invisible para siempre.
    var redSeguridad = window.setTimeout(revelarTodo, 1200);

    try {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('mt-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );
      els.forEach(function (el) {
        observer.observe(el);
      });
    } catch (e) {
      window.clearTimeout(redSeguridad);
      revelarTodo();
    }
  }

  function initFaq() {
    var items = document.querySelectorAll('.mt-faq-item');
    if (!items.length) return;
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (item.open) {
          items.forEach(function (other) {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }

  function initGaleriaProducto() {
    var wrap = document.querySelector('[data-mt-galeria]');
    if (!wrap) return;
    var principal = wrap.querySelector('[data-mt-galeria-principal]');
    var miniaturas = wrap.querySelectorAll('[data-mt-galeria-mini]');
    if (!principal || !miniaturas.length) return;

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var full = mini.getAttribute('data-full');
        var alt = mini.getAttribute('data-alt') || '';
        var videoUrl = mini.getAttribute('data-video');
        var video = wrap.querySelector('[data-mt-galeria-video]');
        if (videoUrl && video) {
          // Miniatura de video: se muestra el video en lugar de la foto grande.
          if (video.getAttribute('src') !== videoUrl) video.setAttribute('src', videoUrl);
          var poster = mini.getAttribute('data-poster');
          if (poster) video.setAttribute('poster', poster);
          principal.hidden = true;
          video.hidden = false;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
          miniaturas.forEach(function (m) { m.classList.remove('mt-galeria-mini--activa'); });
          mini.classList.add('mt-galeria-mini--activa');
          return;
        }
        if (video && !video.hidden) {
          video.pause();
          video.hidden = true;
          principal.hidden = false;
        }
        if (!full) return;
        principal.style.opacity = '0';
        window.setTimeout(function () {
          principal.src = full;
          principal.alt = alt;
          principal.style.opacity = '1';
        }, 150);
        miniaturas.forEach(function (m) {
          m.classList.remove('mt-galeria-mini--activa');
        });
        mini.classList.add('mt-galeria-mini--activa');
      });
    });
  }

  // Selector de variantes con VARIAS opciones (p. ej. Forma + Color).
  // La versión anterior solo escuchaba el primer <select> y comparaba su valor
  // ("Corazón") contra los IDs de variante, así que nunca encontraba nada: el
  // cliente cambiaba la selección y el pedido seguía registrando la primera
  // variante. Ahora se leen TODOS los selectores y se busca la variante cuya
  // combinación de valores coincide exactamente.
  function initSelectorVariantes() {
    var forms = document.querySelectorAll('[data-mt-producto-form]');
    forms.forEach(function (form) {
      var selects = [].slice.call(form.querySelectorAll('[data-mt-variante-select]'));
      var input = form.querySelector('input[name="id"]');
      var precio = form.querySelector('[data-mt-precio]');
      var precioComparado = form.querySelector('[data-mt-precio-comparado]');
      var boton = form.querySelector('[data-mt-boton-comprar]');
      var botonTexto = boton ? boton.querySelector('span') : null;
      var precioBarra = document.querySelector('[data-mt-precio-barra]');
      if (!selects.length || !input) return;

      var dataEl = form.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      function seleccionActual() {
        return selects.map(function (s) {
          return s.value;
        });
      }

      function buscarVariante(valores) {
        for (var i = 0; i < variantes.length; i++) {
          var opts = variantes[i].options || [];
          if (opts.length !== valores.length) continue;
          var iguales = true;
          for (var j = 0; j < valores.length; j++) {
            if (String(opts[j]) !== String(valores[j])) {
              iguales = false;
              break;
            }
          }
          if (iguales) return variantes[i];
        }
        return null;
      }

      // Salta la galería a la foto de la variante elegida (Oso / Corazón).
      // Reutiliza las miniaturas ya existentes para no duplicar lógica.
      function mostrarFotoDeVariante(mediaId) {
        if (!mediaId) return;
        var mini = document.querySelector('[data-mt-galeria-mini][data-media-id="' + mediaId + '"]');
        if (!mini) return;
        if (mini.classList.contains('mt-galeria-mini--activa')) return;
        mini.click();
      }

      function aplicar() {
        var variante = buscarVariante(seleccionActual());
        if (!variante) {
          // Combinación inexistente: no dejamos pedir algo que no se puede servir.
          if (boton) {
            boton.disabled = true;
            if (botonTexto) botonTexto.textContent = boton.getAttribute('data-texto-agotado');
          }
          return;
        }
        input.value = variante.id;
        // Avisamos al resto de la página (y a las apps) de que cambió la variante.
        input.dispatchEvent(new Event('change', { bubbles: true }));
        mostrarFotoDeVariante(variante.media_id);

        if (precio) precio.textContent = variante.price_formatted;
        var ahorro = document.querySelector('[data-dn-ahorro]');
        if (ahorro && !ahorro.hasAttribute('data-dn-oculto')) {
          if (variante.ahorro_formatted) {
            ahorro.textContent = 'Ahorras ' + variante.ahorro_formatted;
            ahorro.hidden = false;
          } else {
            ahorro.hidden = true;
          }
        }
        if (precioBarra) precioBarra.textContent = variante.price_formatted;
        if (precioComparado) {
          if (variante.compare_at_price_formatted) {
            precioComparado.textContent = variante.compare_at_price_formatted;
            precioComparado.hidden = false;
          } else {
            precioComparado.hidden = true;
          }
        }
        if (boton) {
          if (variante.available) {
            boton.disabled = false;
            if (botonTexto) botonTexto.textContent = boton.getAttribute('data-texto-disponible');
          } else {
            boton.disabled = true;
            if (botonTexto) botonTexto.textContent = boton.getAttribute('data-texto-agotado');
          }
        }
      }

      selects.forEach(function (s) {
        s.addEventListener('change', aplicar);
      });
      aplicar();
    });
  }

  function initParallaxHero() {
    var hero = document.querySelector('[data-mt-parallax]');
    if (!hero) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var visual = hero.querySelector('[data-mt-parallax-visual]');
    if (!visual) return;
    var ticking = false;

    function update() {
      var rect = hero.getBoundingClientRect();
      var progreso = 1 - Math.min(Math.max(rect.top / window.innerHeight, -1), 1);
      var desplazamiento = (progreso - 0.5) * 24;
      visual.style.transform = 'translateY(' + desplazamiento + 'px)';
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
    update();
  }

  // Cifras que cuentan hacia arriba al entrar en pantalla.
  function initContadores() {
    var els = document.querySelectorAll('[data-mt-contador]');
    if (!els.length) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      typeof IntersectionObserver === 'undefined'
    ) {
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          var destino = parseFloat(entry.target.getAttribute('data-mt-contador'));
          if (isNaN(destino)) return;
          var duracion = 1100;
          var inicio = null;
          function paso(ts) {
            if (!inicio) inicio = ts;
            var avance = Math.min((ts - inicio) / duracion, 1);
            // easing suave al final
            var eased = 1 - Math.pow(1 - avance, 3);
            entry.target.textContent = Math.round(destino * eased);
            if (avance < 1) window.requestAnimationFrame(paso);
          }
          entry.target.textContent = '0';
          window.requestAnimationFrame(paso);
        });
      },
      { threshold: 0.5 }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
    initFaq();
    initGaleriaProducto();
    initSelectorVariantes();
    initParallaxHero();
  });
})();
